import { useEffect, useState } from "react";
import PopupContent from "../popupContent";
import "./ProductTreeSelector.css";
import "./ProductBreadCrumb.css";
import MainProductGroup from "./MainProductGroup";
import { useTranslation } from "react-i18next";

interface Props {
  productGroups: any[];
  selectedGroups: any[];
  onChange?: any;
}

const MultipleProductGroupSelector = (props: Props) => {

  const { t } = useTranslation(undefined, { keyPrefix: 'ProductGroupsTree' });
  const [selectedGroups, setSelectedGroups] = useState<any[]>([]);
  useEffect(() => {

    setSelectedGroups(props.selectedGroups);
  }, [props.selectedGroups.length]);

  const handleGroupChange = (groupId, checked) => {


    let productGroupDetails = props.productGroups.filter(a => a.id == groupId);
    let productGroupDetail = productGroupDetails.length > 0 ? productGroupDetails[0] : null;

    let newSelectedGroups = props.selectedGroups;

    if (checked) {

      if (productGroupDetail && (productGroupDetail.isRootForDecorative || productGroupDetail.isRootForIndustry)) {
        if (productGroupDetail.childGroups && productGroupDetail.childGroups.length > 0) {
          productGroupDetail.childGroups.forEach(g => {
            newSelectedGroups.push(g.id);
          });
        }
      }

      newSelectedGroups.push(groupId);
      props.onChange(newSelectedGroups);
    }
    else {
      const index = newSelectedGroups.indexOf(groupId);
      if (index > -1) {
        newSelectedGroups.splice(index, 1);

        if (productGroupDetail && (productGroupDetail.isRootForDecorative || productGroupDetail.isRootForIndustry)) {
          if (productGroupDetail.childGroups && productGroupDetail.childGroups.length > 0) {
            productGroupDetail.childGroups.forEach(g => {
              newSelectedGroups = newSelectedGroups.filter(a => a != g.id);
            });
          }
        }

        props.onChange(newSelectedGroups);
      }
    }
  }

  // const handleGroupClick = (e: any, group: any) => {
  //   const checked = e.currentTarget.checked;
  //   if (checked) {
  //     let newSelectedGroups = selectedGroups;
  //     newSelectedGroups.push(group.id);
  //     setSelectedGroups(newSelectedGroups);
  //     props.onChange(newSelectedGroups);
  //   }
  //   else {
  //     let newSelectedGroups = selectedGroups;
  //     const index = newSelectedGroups.indexOf(group.id);
  //     if (index > -1) {
  //       newSelectedGroups.splice(index, 1);
  //       setSelectedGroups(newSelectedGroups);
  //       props.onChange(newSelectedGroups);
  //     }
  //   }
  // }

  const renderGroup = (productGroup: any, nested: boolean) => {
    let isItemSelectable = true;

    let renderedNodeNameOrNameWithNumber = productGroup.name;

    let countOfSlash = productGroup.path.match(new RegExp("/", "g"));
    if (countOfSlash) {
      countOfSlash = countOfSlash.length;
    }
    let renderLeaf = countOfSlash < 2;
    let itemClassName = isItemSelectable
      ? `treeview-item-selectable`
      : `treeview-item`;

    if (productGroup.isRootForDecorative) {
      itemClassName += " rootDecorative";
    }

    if (productGroup.isRootForIndustry) {
      itemClassName += " rootIndustry";
    }

    // const isChecked = () => {
    //   return selectedGroups.find(g => { return g === productGroup.id }) ? true : false;
    // };

    return (
      <>
        {renderLeaf && <ul className={nested ? `nested1` : `treeview-animated-list mb-3`}>
          <li className="">
            <a className="closed">
              <span className="">
                <input type="checkbox" checked={false} onClick={(e) => { }}></input>
                &nbsp;
                {productGroup.isRootForDecorative && (
                  <i className="fas fa-palette ic-w mx-1"></i>
                )}

                {productGroup.isRootForIndustry && (
                  <i className="far fas fa-industry ic-w mx-1"></i>
                )}

                <span
                  className={itemClassName}
                >
                  {renderedNodeNameOrNameWithNumber}
                </span>
                {productGroup.childGroups &&
                  productGroup.childGroups.length > 0 &&
                  productGroup.childGroups.map((childGroup: any) => {
                    return renderGroup(childGroup, true);
                  })}
              </span>
            </a>
          </li>
        </ul>}
      </>
    );
  };

  return (
    <>
      <div className="row">
        <label htmlFor={''} className='col-sm-3'>
          {t('Label')}
        </label>
        <div className="col-sm-9 productTreeSelectorContent">
          <div className="treeview-animated">
            {props.productGroups &&
              props.productGroups.length > 0 &&
              props.productGroups.map((productGroup) => {
                //return renderGroup(productGroup, false);
                return <MainProductGroup
                  productGroup={productGroup}
                  selectedGroups={selectedGroups}
                  onChange={handleGroupChange}
                />
              })}
          </div>
        </div>
      </div>
    </>
  );
};

export default MultipleProductGroupSelector;
